/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const ProgramIcon = props => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} {...props}>
			<g fill='#f7f7fb' data-name='Sustracci\xF3n 10'>
				<path d='M20 19.25H4c-.69 0-1.25-.56-1.25-1.25L2.76 6c0-.69.556-1.251 1.24-1.251H9.69l1.78 1.78.22.22H20c.689 0 1.25.56 1.25 1.25v10c0 .69-.561 1.25-1.25 1.25ZM9.78 15.219c.162.87.927 1.531 1.844 1.531h.75c.916 0 1.682-.66 1.844-1.531a1.878 1.878 0 0 0 1.53-1.844v-.75c0-.916-.66-1.681-1.53-1.843a1.879 1.879 0 0 0-1.844-1.532h-.75c-.917 0-1.682.661-1.844 1.532-.87.162-1.53.927-1.53 1.843v.75c0 .917.66 1.681 1.53 1.844Z' />
				<path
					fill='#848588'
					d='M20 18.5a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5h-8.621l-2-2H4c-.27 0-.49.224-.49.501L3.5 18a.5.5 0 0 0 .5.5h16M9.177 15.823A2.63 2.63 0 0 1 7.5 13.375v-.75a2.63 2.63 0 0 1 1.676-2.448 2.63 2.63 0 0 1 2.45-1.677h.749a2.63 2.63 0 0 1 2.448 1.677 2.63 2.63 0 0 1 1.677 2.448v.75a2.629 2.629 0 0 1-1.677 2.448 2.63 2.63 0 0 1-2.448 1.677h-.75a2.63 2.63 0 0 1-2.448-1.677M20 20H4c-1.103 0-2-.897-2-2l.01-12c0-1.103.893-2 1.99-2h6l2 2h8c1.103 0 2 .897 2 2v10c0 1.103-.897 2-2 2Zm-9.875-8.5c-.62 0-1.125.505-1.125 1.125v.75c0 .62.505 1.125 1.125 1.125h.375v.375c0 .62.505 1.125 1.125 1.125h.75c.62 0 1.125-.505 1.125-1.125V14.5h.375c.62 0 1.125-.505 1.125-1.125v-.75c0-.62-.505-1.125-1.125-1.125H13.5v-.375c0-.62-.505-1.125-1.125-1.125h-.75c-.62 0-1.125.505-1.125 1.125v.375h-.375Z'
				/>
			</g>
			<path fill='none' d='M0 0h24v24H0Z' data-name='Trazado 74123' />
		</svg>
	)
}

export default ProgramIcon
